
export function reviewsAnimation() {
  const item = document.querySelector('.reviews');

  if (item.getBoundingClientRect().top < (window.innerHeight / 2)) {
    item.querySelector('picture').classList.add('active');
    item.querySelector('.reviews__main .list__item:first-child').classList.add('active');

    document.removeEventListener('scroll', reviewsAnimation, false)
  }
}